<template>
	<TIcon>
		<path
			d="M9.025 3.974a.75.75 0 0 1 .538-.915 9.76 9.76 0 0 1 4.875 0 .75.75 0 1 1-.375 1.452 8.258 8.258 0 0 0-4.125 0 .75.75 0 0 1-.913-.537ZM5.043 5.669a9.755 9.755 0 0 0-2.438 4.22.75.75 0 1 0 1.446.4 8.25 8.25 0 0 1 2.063-3.571.75.75 0 0 0-1.071-1.049Zm-.992 9.039a.75.75 0 0 0-1.446.401 9.762 9.762 0 0 0 2.438 4.219.75.75 0 1 0 1.07-1.052 8.263 8.263 0 0 1-2.062-3.568Zm10.012 5.781a8.25 8.25 0 0 1-4.125 0 .748.748 0 0 0-.925.536.75.75 0 0 0 .55.917 9.761 9.761 0 0 0 4.875 0 .75.75 0 0 0-.375-1.453Zm6.81-6.301a.75.75 0 0 0-.923.523 8.24 8.24 0 0 1-2.062 3.57.749.749 0 1 0 1.07 1.05 9.75 9.75 0 0 0 2.438-4.218.751.751 0 0 0-.522-.925Zm-.924-3.895a.75.75 0 1 0 1.446-.401 9.75 9.75 0 0 0-2.438-4.219.75.75 0 1 0-1.07 1.052 8.249 8.249 0 0 1 2.062 3.567v.001Z"
		/>
	</TIcon>
</template>

<script setup lang="ts">
import TIcon from '@/app/common/TIcon.vue'
</script>
